import '../styles/components/cards.css';

const MODES = [
  {
    value: 'age_estimation',
    label: 'Age Estimation',
    desc: 'Estimate age from company website and LinkedIn photos',
  },
  {
    value: 'discovery',
    label: 'LinkedIn Discovery',
    desc: 'Find LinkedIn profiles using name, company, department, city, and province',
  },
];

export default function ModeSelector({ mode, onModeChange }) {
  return (
    <div className="mode-cards">
      {MODES.map(m => (
        <div
          key={m.value}
          className={`mode-card${mode === m.value ? ' selected' : ''}`}
          onClick={() => onModeChange(m.value)}
        >
          <div className="mode-card-label">{m.label}</div>
          <div className="mode-card-desc">{m.desc}</div>
        </div>
      ))}
    </div>
  );
}
